export const WANTED_CONTENT_ID = '0-0-2463';
export const RRR_CONTENT_ID = '0-0-1z5145092';
export const WRITER_PADMABUSHAN_CONTENT_ID = '0-0-1z5323051';
export const SIRF_EK_BANDAA_KAAFI_HAI_CONTENT_ID = '0-0-1z5359029';
export const KISI_KA_BHAI_KISI_KI_JAAN_CONTENT_ID = '0-0-1z5379692';

export const WANTED_AND_WRITER_PADMABUSHAN = [
  'en-us',
  'en-gb',
  'en-ae',
  'en-ca',
  'en-au',
  'en-sa',
  'en-sg'
];
